import React from 'react';
import { ClipboardList, FileUser, Microscope, Bookmark, CalendarCheck, CheckCheck } from 'lucide-react';
import styles from './StudentWelcome.module.css';

const steps = [
  { icon: ClipboardList, label: 'Basic Information', timeEstimate: '30 sec' },
  { icon: Microscope, label: 'Research Interests', timeEstimate: '45 sec' },
  { icon: FileUser, label: 'Resume', timeEstimate: '1 min' },
  { icon: Bookmark, label: 'Save 3 Positions', timeEstimate: '2 min' },
  { icon: CheckCheck, label: 'Match', timeEstimate: 'Instant' },
  { icon: CalendarCheck, label: 'Connect (coming soon)', timeEstimate: 'Varies' },
];

function ProgressTimeline({ currentStep, completedSteps }) {
  const getStepStatus = (index) => {
    if (completedSteps.has(index)) return styles.completed;
    if (index === currentStep && !completedSteps.has(index)) return styles.current;
    return styles.pending;
  };

  return (
    <div className={styles.timelineContainer}>
      <div className={styles.timelineTrack}>
        <div
          className={styles.timelineProgress}
          style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
        ></div>
      </div>
      {steps.map((step, index) => {
        const status = getStepStatus(index);
        return (
          <div key={index} className={styles.timelineStep}>
            <div className={`${styles.stepIcon} ${status}`}>
              <step.icon
                className={styles.icon}
                color={status !== styles.pending ? 'white' : '#061941'}
              />
            </div>
            <span className={styles.stepLabel}>{step.label}</span>
            <div className={`${styles.stepDot} ${status}`}></div>
            <div className={styles.stepNumber}>{index + 1}</div>
            <div className={styles.timeEstimate}>{step.timeEstimate}</div>
          </div>
        );
      })}
    </div>
  );
}

export default ProgressTimeline;